/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_CanceledInputs */

const en_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled`)
};

const de_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgebrochen`)
};

/**
* | output |
* | --- |
* | "Canceled" |
*
* @param {Status_CanceledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const status_canceled = /** @type {((inputs?: Status_CanceledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_CanceledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_status_canceled(inputs)
	return en_status_canceled(inputs)
});